


































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Getter, Action } from 'vuex-class';

import Customer from '@/types/customer/Customer';
import UserInterface from '@/types/app/IUser';
import CompanyService from '@/services/companyService';
import { getFileNameFromLink } from '@/utils/fileName';
import formatDate, { formatDateWithTime } from '@/utils/formatDate';
import Endpoint from '@/utils/endpoint';
import ModalSuccess from '@/components/common/ModalSuccess.vue';
import CompanyInterface, { companyInitialValue } from '@/types/app/companies';
import VuetifySelectItems from '@/types/app/vuetifySelectItems';
import { Prop, Watch } from 'vue-property-decorator';
import CustomerCompany from '@/components/headers/customer-companies';
import Header from '@/types/app/header';
import InvestorHeader from '@/components/headers/investors-header';
import applyCondition from '@/utils/applyCondition';
import InvestorInterface, { investorInitialValue } from '@/types/app/investor';
import { consoleSandbox, stringMatchesSomePattern } from '@sentry/utils';
import ManagerHeader from '@/components/headers/managers-header';
import CrudInvestor from '@/components/common/CrudInvestor.vue';
import CrudManager from '@/components/common/CrudManager.vue';
import BaseComponent from '@/utils/baseComponent';

const namespace = 'customer';

@Component({
  components: { ModalSuccess, CrudInvestor, CrudManager },
  data: () => ({
    endpoint: new Endpoint(),
    tab: String,
    loadingEditCompany: false,
    required: (v: any) => !!v || 'This field is required',
  }),
})

export default class CompanyForm extends BaseComponent {
  [x: string]: any;
  @Getter('getCustomers', { namespace }) customers!: Customer[];
  @Getter('getCompaniesState', { namespace: 'company' })
  getCompanies!: CompanyInterface[];
  formatDate = formatDate;
  formatDateWithTime = formatDateWithTime;
  loading = false;
  loadingEdit = false;
  loadingEditCompany = false;
  company: CompanyInterface = companyInitialValue;
  companyService = new CompanyService(this.$http);
  formTypeChange = 'View';
  tab = "company";
  loadManagers = false;
  constructor() {
    super();
    this.formTypeChange = this.formType;

  }

  async mounted() {
    if (this.companyId) {
      this.company = await this.companyService.getCompanyById(this.companyId);
    }
  }

  get companyId(): string {
    return this.$route.params.companyId
  }

  get formType(): string {
    return this.$route.params.formType
  }

  showViewCompany() {
    this.$router.push({
      name: "CompanyFormView",
      params: {
        companyId: this.company.id,
        formType: 'view'
      }
    });
  }

  showEditCompany() {
    this.$router.push({
      name: "CompanyFormView",
      params: {
        companyId: this.company.id,
        formType: 'edit'
      }
    });
  }

  get isEdit(): boolean {
    return this.formType == 'edit';
  }

  get isView(): boolean {
    return this.formType == 'view';
  }

  get isNew(): boolean {
    return this.formType == 'new';
  }

  async saveCompany() {
    if (!this.form().validate()) {
      return false;
    }
    this.loadingEditCompany = true;
    try {
      if (this.company.id) {
        const result = await this.companyService.saveCompanyInfo(this.company.id, this.company.name,
          this.company.email, this.company.country);
        if (!result.hasErrors) {
          this.showSuccess('Save a company with successfully');
          this.$router.push({
            name: "CompanyFormView",
            params: {
              companyId: this.company.id,
              formType: 'View'
            }
          });
        }
        else {
          this.showError('An error occurred when trying to save the company. Please try again later.');
          return;
        }

      }
      else {
        const result = await this.companyService.saveCompany(this.company);
        if (!result.hasErrors) {
          console.log('create company', result)
          this.showSuccess('Create a company with successfully');
          this.$router.push({
            name: "CompanyFormView",
            params: {
              companyId: result.data,
              formType: 'View'
            }
          });
        } else {
          this.showError('An error occurred when trying to create the company. Please try again later.');
          return;
        }
      }
    }
    catch (ex) {
      console.log(ex);
    }
    finally {
      this.loadingEditCompany = false;
    }
  }


}
